$(document).ready(function(){
    'use strict'

    //Реализация табов
    $('.tabs').each(function() {
        let ths = $(this);
        ths.find('.tabs__item').not(':first').hide();
        ths.find('.tabs__name').on('click',function() {
            const currentTab = ths.find('.tabs__item').eq($(this).index());

            ths.find('.tabs__name').removeClass('active').eq($(this).index()).addClass('active');
            ths.find('.tabs__item').hide()
            currentTab.fadeIn()
            ths.hasClass('js-tabs-form') && disabledInput(currentTab)
        }).eq(0).addClass('active');
    });

    function disabledInput(tabItem) {

        const tabsContent = tabItem.parents('.tabs__content');
        const inputs = tabsContent.find('.cell-input');
        const activeInputs = tabItem.find('.cell-input');

        inputs.attr('disabled', 'disabled');
        inputs.attr('data-required', 'false');
        inputs.val('');
        activeInputs.removeAttr('disabled');
        activeInputs.attr('data-required', 'true');
    }
});
